import React from 'react';
import { Item } from './Item';
import { jsx as _jsx } from "react/jsx-runtime";
export const Operations = ({
  value = []
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: "icloud-ui-pro-table-operations",
    children: value.map(({
      name,
      ...item
    }, index) => /*#__PURE__*/_jsx(Item, {
      name: name,
      ...item
    }, name ? JSON.stringify(name) : index))
  });
};
//# sourceMappingURL=es/Operations.js.map